<template>
  <div id="toast" :class="{ show: isShown, normal: isNormal, error: isError }">
    <h3 :class="{ textNormal: isNormal, textError: isError }">{{ text }}</h3>
  </div>
</template>

<script>
export default {
  props: {
    seconds: {
      type: Number,
      default: 3,
    },
  },

  data() {
    return {
      isShown: false,
      isNormal: false,
      isError: false,
      text: "Default Toast test",
    };
  },

  methods: {
    reset() {
      this.isNormal = false;
      this.isError = false;
    },
    show(t) {
      this.reset();
      this.isNormal = true;
      this.showToast(t);
    },

    showError(t) {
      this.reset();
      this.isError = true;
      this.showToast(t);
    },

    showToast(t = null) {
      if (t != null) {
        this.text = t;
      }

      return new Promise((resolve) => {
        this.isShown = true;
        setTimeout(() => {
          this.isShown = false;
          resolve();
        }, this.seconds * 1000);
      });
    },
  },
};
</script>

<style scoped>
.normal {
  background-color: rgb(96, 189, 60);
}
.error {
  background-color: rgb(214, 60, 60);
}
.textNormal {
  color: #fff;
}
.textError {
  color: #fff;
}
#toast {
  visibility: hidden;
  min-width: 250px;
  margin-left: -125px;
  text-align: center;
  border-radius: 2px;
  padding: 16px;
  position: fixed;
  z-index: 1;
  left: 50%;
  bottom: 30px;
}
#toast.show {
  visibility: visible;
  -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
  animation: fadein 0.5s, fadeout 0.5s 2.5s;
}
@-webkit-keyframes fadein {
  from {
    bottom: 0;
    opacity: 0;
  }
  to {
    bottom: 30px;
    opacity: 1;
  }
}
@keyframes fadein {
  from {
    bottom: 0;
    opacity: 0;
  }
  to {
    bottom: 30px;
    opacity: 1;
  }
}
@-webkit-keyframes fadeout {
  from {
    bottom: 30px;
    opacity: 1;
  }
  to {
    bottom: 0;
    opacity: 0;
  }
}
@keyframes fadeout {
  from {
    bottom: 30px;
    opacity: 1;
  }
  to {
    bottom: 0;
    opacity: 0;
  }
}
</style>
